<template>
  <ServicePageType2
    :pageData="pageData"
    :service="pageData.defaultData.page"
  />
</template>
<script setup>
import { GoogleAnalyticsTrackPage } from '~/utils/googleAnalytics.js';
const tenthUrl = 'https://t1.kakaocdn.net/dkt_corp/service';
const pageData = {
  defaultData: {
    page: 'sap',
    title: 'SAP ERP',
    category: 'SAP ERP',
    slogan: '기업 비즈니스 경영환경에 최적화된 <br class="br_pc">SAP 통합 서비스를 만나보세요',
    image: `https://t1.kakaocdn.net/dkt_corp/service/img_sap.png`,
  },
  seoData: {
    description: '최적화 SAP 통합 서비스',
  },
  infoData: {
    title:
      '기업의 니즈를 완벽하게 반영한 <br class="br_tablet br_mo">맞춤형 시스템을 설계하여<br /> 재무·인사·영업 등 <br class="br_mo" />관리 업무의 <br class="br_pc br_tablet">효율 향상과 <br class="br_mo">운영 비용 절감을 추구합니다',
    description: '',
    image: {
      src: {
        pc: 'https://t1.kakaocdn.net/dkt_corp/service/img_info_sap_pc.png',
        tablet: 'https://t1.kakaocdn.net/dkt_corp/service/img_info_sap_tablet.png',
        mo: 'https://t1.kakaocdn.net/dkt_corp/service/img_info_sap_mo.png',
      },
      alt: '안정적인 서비스 구축과 운영, 최적화된 컨설팅 운영비용 절감, 목표시스템 구축 및 운영으로 최적화된 기업 비즈니스를 제공합니다.',
    },
  },
  experienceData: {
    title: '디케이테크인만의 <br>SAP 비즈니스를 경험하세요',
    list: [
      {
        image: `${tenthUrl}/img_experience_sap1_250114.png`,
        data: [
          {
            name: 'SAP 전문가 컨설팅 서비스',
            description:
              '모듈별 다양한 업무 분야에서 활동 경험이 많은 전문가 그룹이 컨설팅을 진행해요 사업 분야별 업무 프로세스를 설계해 드릴게요',
          },
          {
            name: '서비스 전 분야 아웃소싱',
            description:
              'SAP 관련 FCM 및 SCM 외 BC, BI, PO, 인프라까지 모든 분야에 대한 토탈 서비스를 제공해요',
          },
        ],
      },
      {
        image: `${tenthUrl}/img_experience_sap2.png`,
        data: [
          {
            name: '안정적 시스템 운영',
            description:
              '필수적인 업무를 중점으로 시스템에 대한 고객의 신뢰성을 확보하여 불필요한 리스크를 줄이고 안정적인 시스템 운영을 제공해요',
          },
          {
            name: '다양한 서비스와의 통합',
            description:
              '전자결재, 구매관리 시스템 등 다양한 시스템과의 SAP 통합 서비스를 제공해요',
          },
        ],
      },
    ],
  },
  processData: {
    title: 'SAP 진행 프로세스',
    image: {
      pc: `${tenthUrl}/img_process_sap_pc.png`,
      tablet: `${tenthUrl}/img_process_sap_tablet.png`,
      mo: `${tenthUrl}/img_process_sap_mo.png`,
    },
    description: '이미지 설명',
  },
};

onMounted(() => {
  GoogleAnalyticsTrackPage('sap', 'SAP_ERP_PV');
});
</script>
